<onboarding-container
  [displayProgressBar]="false"
  [formValid]="(facade.submittingOnboardingSavingsPlan$ | async) === false"
  [loading]="facade.submittingOnboardingSavingsPlan$ | async"
  [buttonLabel]="'onboarding.savings-plan.confirm.btn' | transloco"
  (back)="goBack()"
  (forward)="facade.submitOnboardingSavingsPlan()"
>
  <p class="zero-text p-huge-med">{{ 'onboarding.savings-plan.confirm.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.savings-plan.confirm.text' | transloco }}</p>
  @if (facade.onboardingSavingsPlanAsset$ | async; as asset) {
    <hr />
    <div class="d-flex justify-content-between">
      <div class="zero-text p-base-reg">{{ 'onboarding.savings-plan.confirm.labels.buy' | transloco }}</div>
      <div class="zero-text p-base-med">{{ 'onboarding.savings-plan.confirm.values.buy' | transloco }}</div>
    </div>
    <hr />
    <div class="d-flex justify-content-between">
      <div class="zero-text p-base-reg">{{ 'onboarding.savings-plan.confirm.labels.transfer' | transloco }}</div>
      <div class="zero-text p-base-med">{{ 'onboarding.savings-plan.confirm.values.transfer' | transloco }}</div>
    </div>
    <hr />
    <div class="d-flex justify-content-between">
      <div class="zero-text p-base-reg">{{ 'onboarding.savings-plan.confirm.labels.asset' | transloco }}</div>
      <div>
        <div class="zero-text p-base-med text-right">{{ asset.longName }}</div>
        <div class="zero-text p-small-reg text-right">{{ asset.isin }} / {{ asset.wkn }}</div>
        <div class="text-right">
          @if (asset.baseInfoLink) {
            <a [href]="asset.baseInfoLink" class="link-secondary" target="_blank" rel="noopener noreferrer">
              {{ 'savings-plan.savings-plan-summary.links.baseInfoLink' | transloco }}</a
            >,
          }
          @if (asset.salesbrochure) {
            <a [href]="asset.salesbrochure" class="link-secondary" target="_blank" rel="noopener noreferrer">
              {{ 'savings-plan.savings-plan-summary.links.salesbrochure' | transloco }}</a
            >,
          }
          @if (asset.semiAnnualReport) {
            <a [href]="asset.semiAnnualReport" class="link-secondary" target="_blank" rel="noopener noreferrer">
              {{ 'savings-plan.savings-plan-summary.links.semiAnnualReport' | transloco }}</a
            >,
          }
          @if (asset.annualReport) {
            <a [href]="asset.annualReport" class="link-secondary" target="_blank" rel="noopener noreferrer">
              {{ 'savings-plan.savings-plan-summary.links.annualReport' | transloco }}</a
            >,
          }
          @if (facade.onboardingSavingsPlanExante$ | async; as exante) {
            <a class="link-secondary" [href]="exante.uri" target="_blank" rel="noopener noreferrer">{{
              'trade.confirm.exante.link' | transloco
            }}</a>
          } @else {
            {{ 'onboarding.savings-plan.confirm.loading-exante' | transloco }}
          }
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex justify-content-between">
      <div class="zero-text p-base-reg">{{ 'onboarding.savings-plan.confirm.labels.interval' | transloco }}</div>
      <div class="zero-text p-base-med">{{ 'onboarding.savings-plan.confirm.values.interval' | transloco }}</div>
    </div>

    <hr />
    <div class="d-flex justify-content-between">
      <div class="zero-text p-base-reg">{{ 'onboarding.savings-plan.confirm.labels.sum' | transloco }}</div>
      <div class="zero-text p-base-med">{{ facade.onboardingSavingsPlanAmount$ | async | currency }}</div>
    </div>
    @if (facade.onboardingSavingsPlanError$ | async; as error) {
      <div class="mt-3 zero-text course-red">{{ error }}</div>
    }
  }
</onboarding-container>
